import withdrawalService from 'src/services/withdrawal'
import { PlanTypes } from 'src/redux/types/planTypes'
import { TransactionTypes } from 'src/redux/types/transaction'
import { action } from 'typesafe-actions'
import { getValidationErrorMessage } from 'src/utils/response-helpers'

export const WithdrawalAction = ({ payload, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await withdrawalService.makeWithdrawal(payload)
      console.log(response.data.data)

      if (response.data.data && response.data.data.successful) {
        onSuccess(response.data.data.server_response)
        dispatch(action(PlanTypes.GET_USER_PLANS_CALL))
        dispatch(action(TransactionTypes.GET_TRANSACTION_REQUEST_SUCCESS))
      } else {
        onError(response.data.data.message)
      }
    } catch (error) {
      onError(getValidationErrorMessage(error))
    }
  }
}
